import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const HighlighterIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="highlighter" ref={ref} {...props}>
      <path d="M21.84,13.65l-4.66,4.66a.77.77,0,0,1-.84.16c-.08,0-2.19-.9-4.45,1.36a.75.75,0,0,1-1.06,0L9.11,18.1,7.38,16.37a.75.75,0,0,1,0-1.06C9.66,13,8.75,10.88,8.74,10.86A.73.73,0,0,1,8.89,10l7.89-7.9A.76.76,0,0,1,17.85,3.2l-7.57,7.57A5.64,5.64,0,0,1,9,15.82L10.17,17l1.21,1.22a5.62,5.62,0,0,1,5.06-1.33l4.34-4.34a.75.75,0,1,1,1.06,1.06ZM9.78,21.09,6.11,17.42,1.54,22H8.8Z" />
    </Icon>
  ),
) as IconWithRender;

HighlighterIcon.displayName = 'HighlighterIcon';
HighlighterIcon.renderIcon = (props) => <HighlighterIcon {...props} />;
export default HighlighterIcon;
